<script>
export default {
    name: "IconCircleShare"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 3a3 3 0 1 0 3 3M5.5 15a3 3 0 1 0 3 3M18.5 21a3 3 0 1 1 3-3M20 13a7.98 7.98 0 0 0-2.708-6M4 13a7.98 7.98 0 0 1 2.708-6M10 20.748c.64.165 1.31.252 2 .252s1.36-.087 2-.252"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
